import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { ALL_TAB, Dashboard } from '@/features/resources/Dashboard';

const resourcesSearchSchema = z.object({
  tab: z.string().optional(),
  /** When `1`, the create dialog opens on mount. Used by the command palette
   * (cmd+K → New resource) and the Alt+N hotkey. */
  create: z.literal('1').optional(),
});

export const Route = createFileRoute('/_authed/resources')({
  validateSearch: resourcesSearchSchema,
  component: ResourcesPage,
});

function ResourcesPage() {
  const { tab, create } = Route.useSearch();
  const navigate = useNavigate();

  return (
    <Dashboard
      activeTab={tab ?? ALL_TAB}
      setActiveTab={(next) =>
        void navigate({
          to: '/resources',
          search: {
            tab: next === ALL_TAB ? undefined : next,
            create: create ?? undefined,
          },
        })
      }
      createOpen={create === '1'}
      onCreateOpenChange={(open) =>
        void navigate({
          to: '/resources',
          search: { tab, create: open ? '1' : undefined },
        })
      }
    />
  );
}
